import request from '@/services/base/request'

export default {
  list: () => request('/user/sessions/', 'get', undefined),
  history: (page = 1, onlyEnded = false) =>
    request(`/user/sessions/history/?page=${page}${onlyEnded ? '&only_ended=true' : ''}`, 'get', undefined),
  terminate: (sessionId: string) => request(`/user/sessions/${sessionId}/`, 'delete', undefined),
  terminateOthers: () => request('/user/sessions/', 'delete', undefined)
}
